import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Marquee from 'react-fast-marquee';
import { useGetActiveMessagesQuery } from '../services/auth/authApi';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [marqueeMessage, setMarqueeMessage] = useState('श्री श्याम देवाय नमः🙏🙏');

  // Fetch active messages
  const { data: messagesResponse } = useGetActiveMessagesQuery();

 

  useEffect(() => {
    // Update marquee message when API response arrives
    if (messagesResponse?.success && Array.isArray(messagesResponse?.data) && messagesResponse.data.length > 0) {
      // Get the first active message's content
      const firstMessage = messagesResponse.data[0];
      
      if (firstMessage?.content && firstMessage.content.trim()) {
        setMarqueeMessage(firstMessage.content);
        
      }
    }
  }, [messagesResponse]);

  return (
    <div className="min-h-screen" style={{ background: 'var(--bg)' }}>

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Header */}
      <Header
        onMenuClick={() => setSidebarOpen(true)}
        sidebarCollapsed={sidebarCollapsed}
      />

      {/* Marquee */}
      <div
        className={`fixed top-16 right-0 h-7 glass-dark text-[var(--chrome-text)] text-xs uppercase font-semibold tracking-wider flex items-center overflow-hidden z-20 transition-all duration-300
          ${sidebarCollapsed ? 'lg:left-20' : 'lg:left-64'}
          left-0
        `}
      >
        <Marquee speed={50} gradient={false} className="w-full">
          <span className="pl-4">{marqueeMessage}</span>
        </Marquee>
      </div>

      {/* Main Content */}
      <main
        className={`pt-[92px] min-h-screen transition-all duration-300
          ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}
        `}
      >
        <div className="p-0">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
